<template>
  <div class="global-box pricing">
    <div class="content-box">
      <h3>{{$t('index.pricing.title')}}</h3>
      <div class="wrapper-period">
        <p class="title-plans">Planos feitos sob medida para o sucesso de seu negócio!</p>
        <p
          class="period"
          :class="{'selected': !periodDiscount}"
        >
          Plano mensal
        </p>
        <md-switch v-model="periodDiscount" />
        <p
          class="period"
          :class="{'selected': periodDiscount}"
        >
          Plano semestral
        </p>
      </div>
      <div class="global-pricing">
        <div class="unitary-pricing" v-for="(item, index) in plans" :key="index">
          <div class="plan">
            <p class="normal-text">{{$t('index.pricing.plan')}}</p>
            <p class="name-plan">
              {{item.name}}
            </p>
            <p class="normal-text-coin">
              {{$t('index.pricing.coin')}}
              <span>
                {{item[valuePeriod]}}
              </span>
            </p>
            <p
              class="normal-text-value"
              style="height:21px;"
            >
              <span v-if="item.valueMonth !== '0'">
                {{$t('index.pricing.unity_month')}}
                <span v-if="item.name !== 'Basic'">
                  {{$t('index.pricing.unity')}}
                </span>
              </span>
            </p>
          </div>
          <div class="description">
            <ul>
              <li v-for="(itm, indx) in item.descriptions" :key="indx">
                {{itm}}
              </li>
            </ul>
          </div>
          <div class="register">
            <router-link
              to="/registrations"
            >
              <btn
                :description="$t('index.pricing.register')"
                small
                outline
                class="btn"
              />
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'pricing',
  data() {
    return {
      plans: [
        {
          id: 1,
          name: 'Basic',
          valueMonth: '0',
          valuePeriod: '0',
          descriptions: [
            `${this.$t('index.pricing.only')} 1 ${this.$t('index.pricing.user')}`,
            `${this.$t('index.pricing.up_to')} 50 ${this.$t('index.pricing.register_clients')}`,
            `${this.$t('index.pricing.support')} ${this.$t('index.pricing.per_mail')}`,
          ],
        },
        {
          id: 2,
          name: 'Medium',
          valueMonth: '59,99',
          valuePeriod: '50,49',
          descriptions: [
            `${this.$t('index.pricing.up_to')} 2 ${this.$t('index.pricing.user')}s`,
            `${this.$t('index.pricing.up_to')} 200 ${this.$t('index.pricing.register_clients')}`,
            `${this.$t('index.pricing.support')} ${this.$t('index.pricing.per_mail')}`,
          ],
        },
        {
          id: 3,
          name: 'Control',
          valueMonth: '89,99',
          valuePeriod: '76,49',
          descriptions: [
            `${this.$t('index.pricing.unlimited')} ${this.$t('index.pricing.user')}s`,
            `${this.$t('index.pricing.unlimited')} ${this.$t('index.pricing.register_clients')}`,
            `${this.$t('index.pricing.support')} ${this.$t('index.pricing.online')}`,
          ],
        },
      ],
      periodDiscount: true,
      valuePeriod: 'valuePeriod',
    };
  },
  watch: {
    periodDiscount() {
      this.displayValue();
    },
  },
  methods: {
    displayValue() {
      if (this.periodDiscount) {
        this.valuePeriod = 'valuePeriod';
      } else {
        this.valuePeriod = 'valueMonth';
      }
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "../assets/sass/main.sass"
  .pricing
    margin-bottom: 52px
    h3
      width: 100%
    .wrapper-period
      width: 100%
      display: flex
      flex-wrap: wrap
      align-items: center
      justify-content: center
      .title-plans
        width: 100%
        text-align: center
        margin: 20px 0
        font-size: 20px
        font-weight: 300
        color: $brand-twoo
      .period
        font-weight: 300
        font-size: 18px
        &.selected
          text-decoration: underline
          color: $brand-twoo
          font-weight: 600
        &:first-child
          text-align: right
      .md-switch
        margin: 0 12px
    .global-pricing
      width: 100%
      display: flex
      flex-wrap: nowrap
      justify-content: space-around
      .unitary-pricing
        width: 250px
        border: 1px solid $brand-twoo
        margin-top: 24px
        border-radius: 20px
        &:hover
          box-shadow: 5px 5px 5px 0px $grey-300
        .plan, .description, .register
          padding: 12px 20px
          display: flex
          flex-wrap: wrap
          justify-content: center
          padding: 40px 0
        .plan
          border-radius: 20px 20px 0 0
          background-color: $white
          .normal-text
            font-size: 18px
            font-weight: 300
            text-transform: lowercase
          .name-plan
            font-weight: 700
            text-transform: uppercase
            color: $brand-twoo
            font-size: 22px
          .normal-text-coin
            font-size: 14px
            display: flex
            justify-content: center
            align-items: center
            span
              font-size: 26px
              font-weight: 600
              margin-left: 4px
          .normal-text-value
            font-size: 14px
            font-weight: 300
            font-style: italic
          p
            width: 100%
            text-align: center
            color: $grey-900
        .description
          background-color: $secundary
          ul li
            text-align: center
            text-transform: lowercase
        .register
          background-color: $white
          border-radius: 0 0 20px 20px
    @media (max-width: $widthTerciary)
      .global-pricing
        flex-wrap: wrap
        .unitary-pricing
          width: 100%
</style>
